﻿var mscc;
function initMsaMigrationPage(options) {

    $(function () {
        $.validator.unobtrusive.parse(options.formId);

        var migrationButton = $(options.migrationButtonId);
        var submitButton = $(options.submitButtonId);
        var existingMsaAction = $(options.existingEmailActionId);
        var newMsaAction = $(options.newEmailActionId);
        var remindLaterAction = $(options.remindLaterActionId);
        var checkEmailAvailabilityButton = $(options.checkEmailButtonId);
        var emailGroup = $(options.migrateToEmailGroupId);
        var emailInputBox = $(options.emailInputId);
        var msccBannerEl = $('#msccBanner')[0];

        if (checkEmailAvailabilityButton.length !== 0) {
            emailGroup.show();
            existingMsaAction.change(function() {
                emailGroup.show();
                $(options.allCheckEmailMessagesId).hide();
                checkEmailAvailabilityButton.prop('disabled', false);
                migrationButton.hide();
                submitButton.prop('disabled', true);
                $(options.signupNewMsaMessageId).hide();
                emailInputBox.removeClass(options.inputValidationErrorClass);
            });

            newMsaAction.change(function() {
                emailGroup.hide();
                emailInputBox.val('');
                migrationButton.show();
                $(options.signupNewMsaMessageId).show();
                submitButton.prop('disabled', false);
            });

            remindLaterAction.change(function() {
                emailGroup.hide();
                migrationButton.show();
                $(options.signupNewMsaMessageId).hide();
                submitButton.prop('disabled', false);
            });

            if (emailInputBox.length !== 0) {
                emailInputBox.focus();
                submitButton.prop('disabled', true);
                emailInputBox.focus(function() {
                    checkEmailAvailabilityButton.prop('disabled', false);
                    $(options.allCheckEmailMessagesId).hide();
                    migrationButton.hide();
                    submitButton.prop('disabled', true);
                    emailInputBox.removeClass(options.inputValidationErrorClass);
                });

                checkEmailAvailabilityButton.click(function() {
                    if (msccBannerEl && mscc) {
                        mscc.setConsent();
                    }

                    var emailInput = emailInputBox[0].value;
                    var emailIdPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                    var isEmailFormat = emailIdPattern.test(emailInput);

                    // Email length limits: Gmail - 30, Yahoo - 32, Microsoft - 64. We use 100 here considering there are emails from other organizations with different limits.
                    if (emailInputBox[0].value.length > 100 || !isEmailFormat) {
                        $(options.invalidEmailMessageId).show();
                        emailInputBox.addClass(options.inputValidationErrorClass);
                        checkEmailAvailabilityButton.prop('disabled', true);
                        return;
                    }

                    $.advertiser.ajaxPost({
                        url: options.checkEmailUrl,
                        data: {
                          email: emailInput,
                          activationCode: options.activationCode
                        },
                        onSuccess: function(data) {
                            if (data) {
                                if (!data.Errors || data.Errors.length === 0)
                                {
                                    $(getTagIdForMessage(data, options)).show();
                                    checkEmailAvailabilityButton.prop('disabled', true);
                                    if (data.PersonUserNameAvailable) {
                                        // Merge User with exisitng MSA if Person Username is available
                                        onEmailAvailableShowSubmitButton(data, options);
                                    }
                                    else if (!data.IsUserNameAvailable || data.PersonId != null || data.IsBingAdsApiReserved || data.CustomerCollisionDetected || data.IsAad) {
                                        // show invalid email id if the email id belongs to secondary user of the person or
                                        // if it belongs to bingads user name or is reserved by API users
                                        emailInputBox.addClass(options.inputValidationErrorClass);
                                    }
                                    else {
                                        // The email is neither a existed Bing Ads account, nor a valid MSA account,
                                        // nor an AAD account. Then create MSA account with this email.
                                        onEmailAvailableShowSubmitButton(data, options);
                                    }
                                }
                            }
                        }
                    });
                });
            }

            if (msccBannerEl) {
                migrationButton.on('click', function () {
                    mscc && mscc.setConsent();
                });
            }

        }

        var autoRedirectMessage = $(options.autoRedirectMsgId);
        if (autoRedirectMessage.length !== 0) {
            UpdateAutoRedirectTimer(options.autoRedirectTime, options.autoRedirectUrl, options.autoRedirectTimerId);
        }
    });
}

function getTagIdForMessage(data, options) {
    if (data.PersonUserNameAvailable && data.IsMultiUser) {
        return options.validMultiUserMessageId;
    }
    if (data.PersonUserNameAvailable && data.IsMsa) {
        return options.validMsaMessageId;
    }
    if (data.CustomerCollisionDetected) {
        return options.customerCollisionMessageId;
    }
    if (!data.IsUserNameAvailable || data.IsBingAdsApiReserved) {
        return options.usedMsaMessageId;
    }
    if (data.IsAad) {
        return options.validAadMessageId;
    }
    if (data.IsMsa) {
        return options.validMsaMessageId;
    }

    return options.validNonMsaMessageId;
}

function onEmailAvailableShowSubmitButton(data, options) {
    $(options.migrationButtonId).show();
    $(options.submitButtonId).prop('disabled', false);
    $(options.isMsaFlagId).val(data.IsMsa);
    $(options.isAadFlagId).val(data.IsAad);
}

function UpdateAutoRedirectTimer(time, redirectUrl, selector) {
    var timeSpan = $(selector);
    if (timeSpan.length > 0) {
        timeSpan[0].innerHTML = time;
        time--;
        if (time < 0) {
            window.location.href = redirectUrl;
        }
        else {
            window.setTimeout(function () { UpdateAutoRedirectTimer(time, redirectUrl, selector); }, 1000);
        }
    }
}

window.initMsaMigrationPage = initMsaMigrationPage;
